import { render, staticRenderFns } from "./registration.html?vue&type=template&id=a69e8178&scoped=true&external"
import script from "./registration.vue?vue&type=script&lang=js"
export * from "./registration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69e8178",
  null
  
)

export default component.exports